import { useEffect } from "react"
import { logout } from "../../components/Menu/menu.support"
import { useNavigate } from "react-router-dom"
import { useAtom } from "jotai"
import { userDetailsAtom, userProfileDataAtom } from "../../components/Menu/menu.store"

export const Logout = (): JSX.Element => {
  const navigate = useNavigate()
  const [, setUserDetailsAtom] = useAtom(userDetailsAtom)
  const [, setUserProfileDataAtom] = useAtom(userProfileDataAtom)
  useEffect(() => {
    logout(navigate)
    setUserDetailsAtom(null)
    setUserProfileDataAtom({})
  }, [navigate, setUserDetailsAtom, setUserProfileDataAtom])

  return <div>Logout</div>
}
